import { Slide, ToastContainer, toast as toastType } from 'react-toastify'

import BodyClassName from 'react-body-classname'
import useWebviewNavigation from '../../modules/hooks/webview/common/useWebviewNavigation'
import NavBar from './caf/common/NavBar'
declare global {
  interface Window {
    navigation: any
  }
}
const WebviewContainer = ({
  children,
  headerShown = true,
  title,
  capitalize = true,
  data,
}: {
  children?: any
  headerShown?: boolean
  title?: string
  capitalize?: boolean
  data?: any
}) => {
  const { popBackToRingleApp } = useWebviewNavigation()

  const onClickNavBarBackBtn = () => {
    if (window?.navigation?.canGoBack) {
      window.history.back()
    } else if (window) {
      popBackToRingleApp(data)
    }
  }
  return (
    <div
      className="select-none bg-white"
      style={{
        marginTop: headerShown ? '98px' : 0,
      }}
    >
      <BodyClassName className="webview-caf" />
      <NavBar
        title={title}
        capitalize={capitalize}
        headerShown={headerShown}
        handleClickBackBtn={onClickNavBarBackBtn}
      />

      <ToastContainer
        style={{ marginBottom: '24px' }}
        toastClassName="text-center flex items-center justify-center shadow-none !bg-transparent"
        bodyClassName="!flex-none flex items-center min-h-0 bg-[#000000] bg-opacity-80 text-white text-center text-[14px] rounded-[5px] flex !py-[8px] border px-[16px] text-center items-center justify-center"
        position={toastType.POSITION.BOTTOM_CENTER}
        closeButton={false}
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        transition={Slide}
        pauseOnHover
        enableMultiContainer
      />
      <section className={`overflow-y-scroll`} style={{ marginTop: headerShown ? '90px' : 0 }}>
        {children}
      </section>
    </div>
  )
}

export default WebviewContainer
